import { Component, OnInit, Injectable } from '@angular/core';
import { AlertController,LoadingController} from '@ionic/angular';
import { NavController } from '@ionic/angular';
import { GlobalService } from '../environments/GlobalService';
import { Storage } from '@ionic/storage';


@Injectable()
export class CusromAlert{
    isLoading = false;
  constructor( public alertController: AlertController,
    public loadingController: LoadingController,
    public navCtrl: NavController,
    public globalService: GlobalService,
    public storage: Storage,) { }

  async presentAlert(msg) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert',
      message: msg,
      buttons: ['OK']
    });
    await alert.present();
  }
  async presentAlertWithConfirmation(msg) {
    const alert = await this.alertController.create({
      header: 'Alert',
      cssClass: 'my-custom-class',
      message: msg,
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            this.storage.set('refresh', 1);
            this.navCtrl.back();
            
          }
        }
      ]
    });
    alert.present();
  }
  async presentLoding() {
    this.isLoading = true;
    return await this.loadingController.create({
      message: 'Please wait...'
    }).then(a => {
      a.present().then(() => {
        if (!this.isLoading) {
          a.dismiss().then(() => {

          });
        }
      });
    });
  }
  async presentLodingDynamicMessage(message) {
    this.isLoading = true;
    return await this.loadingController.create({
      message: message+'. Please wait...'
    }).then(a => {
      a.present().then(() => {
        if (!this.isLoading) {
          a.dismiss().then(() => {
          });
        }
      });
    });
  }
  async presentLodingCustomMessage() {
    this.isLoading = true;
    return await this.loadingController.create({
      message: 'Verifying user information. Please wait...'
    }).then(a => {
      a.present().then(() => {
        if (!this.isLoading) {
          a.dismiss().then(() => {
          });
        }
      });
    });
  }

  async dismissLoading() {
    this.isLoading = false;
    return await this.loadingController.dismiss().then(() => {
    });
  }
  validateEmail(elementValue) {
    var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(elementValue);
  }
}
